import useAudioPlayerStore from "src/stores/useAudioPlayerStore";
import LazyAudioPlayerInternal from "./components/LazyAudioPlayerInternal";

const LazyAudioPlayer = () => {
	const currentAudio = useAudioPlayerStore((state) => state.currentAudio);

	if (!currentAudio) return null;
	return <LazyAudioPlayerInternal audioUrl={currentAudio.audioUrl} />;
};
export default LazyAudioPlayer;
